import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
})
export class HelpModalComponent {
  @Input() terms: { title: string; definition: string; dataCy: string }[];
  @Input() sectionName: string;

  constructor(
    private readonly platformService: PlatformService,
    private readonly modalController: ModalController,
  ) {}

  async closeModal() {
    await this.modalController.dismiss();
  }

  get isDesktop(): boolean {
    return (
      this.platformService.getPlatformType() ===
      this.platformService.platformEnum.desktop
    );
  }
}
